<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'report-one' }">
        ข้อมูลสมาชิก (ผู้ซื้อ)
      </b-breadcrumb-item>
      <b-breadcrumb-item active> รายการสมาชิก (ผู้ซื้อ) </b-breadcrumb-item>
    </b-breadcrumb>

    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <users-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>แสดง</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>รายการ</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="ค้นหา..."
              />
              <!-- <b-button variant="primary" :to="{ name: 'member-add' }">
                <span class="text-nowrap">Add Contact</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative fix-minHeight-table"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="ไม่พบข้อมูลที่ค้นหา"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: User -->
        <template #cell(contactNo)="data">
          <b-media vertical-align="center">
            <b-link
              :to="{ name: 'member-view', params: { id: data.item.contactId } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.contactNo }}
            </b-link>
          </b-media>
        </template>

        <template #cell(contactId)="data">
          <b-media vertical-align="center">
            <b-link
              :to="{ name: 'member-view', params: { id: data.item.contactId } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.contactId }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(contactType)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.contactType)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.contactType)}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.contactType
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(active)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.active)}`"
            class="text-capitalize"
          >
            {{ data.item.active ? "Active" : "Inactive" }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              :to="{
                name: 'member-view',
                params: { id: data.item.contactId },
              }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">ดูข้อมูล</span>
            </b-dropdown-item>

            <b-dropdown-item
              :to="{
                name: 'member-view',
                params: { id: data.item.contactId, isEdit: true },
              }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">แก้ไข</span>
            </b-dropdown-item>

            <!-- <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >แสดง {{ dataMeta.from }} ถึง {{ dataMeta.to }} จาก
              {{ dataMeta.of }} รายการ</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal id="modal-center" centered title="Status" ok-only ok-title="Save">
      <b-form-group>
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./MembersListFilters.vue";
import useUsersList from "./useMembersList";
import userStoreModule from "../userStoreModule";
import UserListAddNew from "./MemberListAddNew.vue";
import saleOrder from "../../orders/orderStoreModule";
import useOrderList from "../../orders/orders-list/useOrdersList";
export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBreadcrumb,
    BBreadcrumbItem,
    vSelect,
  },
  data() {
    return {
      selected: { title: "Active" },

      option: [{ title: "Active" }, { title: "Inactive" }],
    };
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "members";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    const SALE_ORDER_STORE_MODULE_NAME = "saleOrder";

    // Register module
    if (!store.hasModule(SALE_ORDER_STORE_MODULE_NAME))
      store.registerModule(SALE_ORDER_STORE_MODULE_NAME, saleOrder);
    // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME))
    //     store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    // });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const planOptions = [
      { label: "เกษตกร", value: "basic" },
    { label: "บุคคลทั่วไป", value: "basic2" },
    { label: "วิสาหกิจ", value: "basic3" }
      // { label: "All", value: "" },
      // { label: "Seller", value: "Seller" },
      // { label: "Buyer", value: "Buyer" },
    ];

    const statusOptions = [
            { label: "ทั้งหมด", value: "" },
      { label: "ใช้งาน", value: "active" },
      { label: "ไม่ใช้งาน", value: "inactive" },
      // { label: "All", value: "" },
      // { label: "Active", value: "active" },
      // { label: "Inactive", value: "inactive" },
    ];

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList();

    const { fetchOrders } = useOrderList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      fetchOrders,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.fix-minHeight-table {
  min-height: 15rem;
}
</style>
